module.exports = __webpack_public_path__ + "img/eye_closed_icon.3ecb4351.svg";